import React from "react";

import "./style.scss";

const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <p className="footer-text">Copyright © 2022 MealMe Final Project, Designed by Bhakti Buana and Lelita Vikri</p>
      </div>
    </>
  );
};

export default Footer;
